import React from "react";
import styled from "styled-components/macro";
import { useMediaQuery } from "react-responsive";
import { device } from "../device";

import tuluLogoWhite from "../../images/tuluLogoWhite.png";

const FooterMyTulu = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <Wrapper>
      <IconWrapper>
        <ImgIcon
          style={{
            paddingBottom: isMobile ? "0px" : "10px",
          }}
          src={tuluLogoWhite}
        />
      </IconWrapper>

      <IconWrappers>
        <IconWrapper>
          {/* <Img src={nyc} /> */}
          <City>US</City>
          <Title>27 West 20 Street, {isMobile && <br />}New York, NY</Title>
          <Title>sales@tulu.io</Title>
        </IconWrapper>

        <IconWrapper>
          {/* <Img src={ldn} /> */}
          <City>EU</City>
          <Title>85-87 Bayham Street, {isMobile && <br />}London, UK</Title>
          <Title>peter@tulu.io</Title>{" "}
        </IconWrapper>
      </IconWrappers>
    </Wrapper>
  );
};

export { FooterMyTulu };

const Wrapper = styled.div`
  display: flex;
  //position: relative;
  color: white;
  font-family: "DMSans", serif;
  background-color: #1a3944;
  @media ${device.mobileS} {
    flex-direction: row;
    padding: 29px;
  }
  @media ${device.tablet} {
    flex-direction: column;
    padding: 100px;
  }
  @media (min-width: 1240px) {
    padding: 100px;
    flex-direction: row;
    align-items: flex-end;
  }
`;

const IconWrappers = styled.div`
  display: flex;
  flex-direction: row;
  @media ${device.mobileS} {
    width: 64%;
  }
  @media ${device.tablet} {
    width: calc(100vw - 200px);
  }
  @media (min-width: 1240px) {
    width: 50vw;
  }
`;

const IconWrapper = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  @media ${device.mobileS} {
    width: calc((100vw - 60px) / 3);
  }
  @media ${device.tablet} {
    width: 280px;
  }
`;

const Img = styled.img`
  @media ${device.mobileS} {
    height: 20px;
  }
  @media ${device.tablet} {
    /* object-fit: contain; */
    height: 73px;
  }
`;

const City = styled.span`
  font-family: "Lexend";
  font-weight: bold;
  @media ${device.mobileS} {
    font-size: 16px;
  }
  @media ${device.tablet} {
    font-size: 65px;
  }
`;

const ImgIcon = styled(Img)`
  @media ${device.mobileS} {
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: auto;
  }
  @media ${device.tablet} {
    padding-bottom: 0px;
    margin-bottom: 30px;
  }
  @media (min-width: 1240px) {
    padding-bottom: 10px;
    margin-bottom: 0px;
  }
`;

const Title = styled.div`
  font-family: DMSans, serif;
  white-space: pre-wrap;
  @media ${device.mobileS} {
    font-size: 9px;
  }
  @media ${device.tablet} {
    font-size: 20px;
  }
`;
